<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Master/Product'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <!-- <i class="kt-font-brand flaticon-open-box"></i> -->
              <i class="fa fa-cubes"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="PrlKeyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก รหัสสินค้า, ชื่อสินค้า โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น ชื่อสินค้า1, ชื่อสินค้า2"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PrlProductBrandId'"
                    :name="'PrlProductBrandId'"
                    :multiple="true"
                    :select2-options="PrlProductBrandIdOptions"
                    v-model="PrlProductBrandId"
                    ref="PrlProductBrandIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="PrlProductBrandId"
                    :multiple="true"
                    :options="PrlProductBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>หมวดหมู่สินค้า:</label>
                  <!-- <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PrlProductGroupId'"
                    :name="'PrlProductGroupId'"
                    :multiple="true"
                    :select2-options="PrlProductGroupIdOptions"
                    v-model="PrlProductGroupId"
                    ref="PrlProductTypeIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="PrlProductGroupId"
                    :multiple="true"
                    :options="PrlProductGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :class="'form-control m-select2'"
                    :style="'width: 100%;'"
                    :id="'PrlProductTypeId'"
                    :name="'PrlProductTypeId'"
                    :multiple="true"
                    :select2-options="PrlProductTypeIdOptions"
                    v-model="PrlProductTypeId"
                    ref="PrlProductTypeIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="PrlProductTypeId"
                    :multiple="true"
                    :options="PrlProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สินค้าสำหรับใบHold(รับคืน):</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'PrlIsForJobHold'"
                    :name="'PrlIsForJobHold'"
                    :select2-options="PrlIsForJobHoldOptions"
                    v-model="PrlIsForJobHold"
                    ref="PrlIsForJobHoldSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>มีข้อมูลรหัสบาร์โค้ด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'PrlHasBarcode'"
                    :name="'PrlHasBarcode'"
                    :select2-options="PrlHasBarcodeOptions"
                    v-model="PrlHasBarcode"
                    ref="PrlIsForJobHoldSelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทอะไหล่งาน PM:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'PrlPMSpareCode'"
                    :name="'PrlPMSpareCode'"
                    :select2-options="PrlPMSpareCode"
                    v-model="PrlPMSpareCode"
                    ref="PrlPMSpareCodeSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="PrlPMSpareCode"
                    :multiple="true"
                    :options="PrlPMSpareCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'PrlStatus'"
                    :name="'PrlStatus'"
                    :select2-options="PrlStatusOptions"
                    v-model="PrlStatus"
                    ref="PrlStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="ProductTable"
              >
                <thead>
                  <tr>
                    <th class="all">รหัสสินค้า</th>
                    <th class="all">ชื่อสินค้า</th>
                    <th class="all">แบรนด์สินค้า</th>
                    <th class="all">หมวดหมู่</th>
                    <th class="all">ประเภทสินค้า</th>
                    <th class="all">หน่วยนับ</th>
                    <th class="none">สินค้าสำหรับใบHold(รับคืน)</th>
                    <th class="none">BARCODE</th>
                    <th class="none">ประเภทอะไหล่งาน PM</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#ProductTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Product/" + this.data.materialCode + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#ProductTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/Product/" + this.data.materialCode + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="details" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-file-text"></i>
    </a>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="confirmDel" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    details: function() {
      router.push({
        path: `/Master/Product/Detail/${this.data.materialCode}`,
      });
    },
    edit: function() {
      router.push({
        path: `/Master/Product/Update/${this.data.materialCode}`,
      });
    },
    confirmDel: function() {
      Swal.fire({
        title: "ลบข้อมูล",
        type: "warning",
        text: "ต้องการลบข้อมูลหรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then(function(result) {
        if (result.value) {
          //Swal.fire({ type: "success", text: "You have a bike!" });
        } else if (result.value === 0) {
          //Swal.fire({ type: "error", text: "You don't have a bike :(" });
        } else {
          //console.log(`modal was dismissed by ${result.dismiss}`);
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      PrlKeyword: "",
      PrlStatus: "",
      PrlIsForJobHold: "",
      PrlHasBarcode: "",
      PrlProductBrandId: [],
      PrlProductGroupId: [],
      PrlProductTypeId: [],
      PrlPMSpareCode: [],
      PrlPMSpareCodeOptions: [],
      // PrlPMSpareCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทอะไหล่งาน PM",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PMSPARE_CODE",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlProductBrandIdOptions: [],
      // PrlProductBrandIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlProductGroupIdOptions: [],
      // PrlProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlProductTypeIdOptions: [],
      // PrlProductTypeIdOptions: {
      //   placeholder: "กรุณาเลือก",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      PrlStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      PrlIsForJobHoldOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "true", text: "ใช้งาน", data: null },
          { id: "false", text: "ปิดใช้งาน", data: null },
        ],
      },
      PrlHasBarcodeOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "true", text: "มี BARCODE", data: null },
          { id: "false", text: "ไม่มี BARCODE", data: null },
        ],
      },
    };
  },
  methods: {
    formReset: function(e) {
      this.PrlKeyword = "";
      this.PrlPMSpareCode = [];
      this.PrlProductBrandId = [];
      this.PrlProductGroupId = [];
      this.PrlProductTypeId = [];

      $("#PrlProductBrandId")
        .val("")
        .trigger("change");

      $("#PrlProductTypeId")
        .val("")
        .trigger("change");

      $("#PrlProductGroupId")
        .val("")
        .trigger("change");

      $("#PrlIsForJobHold")
        .val("")
        .trigger("change");

      $("#PrlHasBarcode")
        .val("")
        .trigger("change");

      $("#PrlPMSpareCode")
        .val("")
        .trigger("change");

      //default Active Data
      this.PrlStatus = false;
      $("#PrlStatus")
        .val(this.PrlStatus + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#ProductTable").DataTable();
      //table.search(this.id);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#ProductTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    LoadPrlProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.PrlProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadPrlProductGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.PrlProductGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadPrlProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.PrlProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadPrlPMSpareCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PMSPARE_CODE", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.PrlPMSpareCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    //default Active Data
    self.PrlStatus = false;
    $("#PrlStatus")
      .val(self.PrlStatus + "")
      .trigger("change");

    self.LoadPrlProductBrandIdOptions();
    self.LoadPrlProductGroupIdOptions();
    self.LoadPrlProductTypeIdOptions();
    self.LoadPrlPMSpareCodeOptions();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#ProductTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Product/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            console.log(self.PrlPMSpareCode);
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.PrlKeyword,
                ActiveStatus: self.PrlStatus,
                ProductType: self.PrlProductTypeId,
                ProductBrand: self.PrlProductBrandId,
                ProductGroup: self.PrlProductGroupId,
                IsForJobHold: self.PrlIsForJobHold,
                HasBarcode: self.PrlHasBarcode,
                PMSpareCode: self.PrlPMSpareCode,
              })
            );
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[0, "asc"]],
        select: {
          style: "multi",
          selector: "td:first-child",
        },
        columns: [
          { data: "materialCode", className: "text-center" },
          { data: "materialDesc_th2", className: "text-center" },
          { data: "materialBrandDesc", className: "text-center" },
          { data: "materialGrpDesc", className: "text-center" },
          { data: "materialTypeDesc", className: "text-center" },
          { data: "baseUnit", className: "text-center" },
          {
            data: "isForJobHold",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return data ? "เปิดใช้งาน" : "ปิดใช้งาน";
            },
          },
          {
            data: "hasBarcode",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              return data ? "มีข้อมูล BARCODE" : "ไม่มีข้อมูล BARCODE";
            },
          },
          { data: "pmSpareName", className: "text-center", orderable: false },
          {
            data: "status",
            className: "text-center",
            width: "12%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "materialCode",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_PRODUCT",
            ]);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });

        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_PRODUCT",
            ]);
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_PRODUCT",
            ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Product/ProductList.vue